/**
 * @file: useIsFocused$.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCreation } from '@euler/utils/hooks';
import { useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';
import { BehaviorSubject, Observable } from 'rxjs';

export function useIsFocused$(): Observable<boolean> {
  const nav = useNavigation();
  const isFocused$ = useCreation(() => new BehaviorSubject(true), []);
  useEffect(() => {
    const onFocused = () => isFocused$.next(true);
    const onBlurred = () => isFocused$.next(false);
    const focusSub = nav.addListener('focus', onFocused);
    const blurSub = nav.addListener('blur', onBlurred);
    return () => {
      focusSub();
      blurSub();
    };
  }, [isFocused$, nav]);
  return isFocused$;
}
